// hjjtw prod
const url = {
  apiHost: 'https://api.heijiajia.com.tw/',
  socket: 'wss://p8jhkg8n18.execute-api.ap-northeast-2.amazonaws.com/prod/',
  unAuthSocket:
    'wss://ljw5ggo9b5.execute-api.ap-northeast-2.amazonaws.com/prod/',
  cdn: 'https://cdn.heijiajia.com.tw/',
  publicVideoCdn: 'https://public-video-cdn.heijiajia.com.tw/',
  backstage:
    'http://backstage.hjjtw.weiqi.study.s3-website.ap-northeast-2.amazonaws.com/',
  homepage: 'http://hjjtw.weiqi.study.s3-website.ap-northeast-2.amazonaws.com/',
};

export default url;
